import { api } from './graphql';

api.enhanceEndpoints({
  endpoints: {
    GetPaymentProcessors: { providesTags: ['PaymentProcessor'] },
    CreatePaymentProcessor: { invalidatesTags: ['PaymentProcessor'] },
    UpdatePaymentProcessor: { invalidatesTags: ['PaymentProcessor'] },
    ActivatePaymentProcessor: { invalidatesTags: ['PaymentProcessor'] },
    DeactivatePaymentProcessor: { invalidatesTags: ['PaymentProcessor'] },
    DeletePaymentProcessor: { invalidatesTags: ['PaymentProcessor'] },
  },
});
